export const tickerItems = [
  '【存档】本周黑料整理完成 12 条记录，全集已归档入库',
  '【合集】年度十大黑料合集票选开启，评论区已经吵翻',
  '【更新】三年前旧料二次核对后重新上架存档专区',
  '【专题】综艺翻车名场面黑料整理专题今日上线',
  '【排行】黑料大全热度榜刷新，榜首连续霸榜七天',
  '【功能】新增批量备份入口，支持离线保存整份黑料存档',
];

export const heroFeature = {
  category: '今日头条',
  badge: '置顶存档',
  title: '顶流组合解散风波全程记录：从官宣到互撕的黑料存档',
  summary:
    '从成员合约细节到后台争执录音，我们用七天时间把这场风波的时间线完整整理归档，每条物料都标注了来源与时间戳，方便对照查看。',
  time: '2 小时前',
  comments: 1286,
  views: '8.6 万',
  image:
    'https://readdy.ai/api/search-image?query=Dramatic%20editorial%20entertainment%20news%20scene%20with%20deep%20crimson%20spotlight%20beams%20cutting%20through%20dark%20smoke%2C%20abstract%20anonymous%20silhouette%20of%20a%20figure%20behind%20frosted%20glass%2C%20high%20contrast%20moody%20studio%20photography%2C%20warm%20amber%20and%20red%20tones%2C%20cinematic%20gossip%20magazine%20cover%20aesthetic&width=1600&height=900&seq=hcg-hero-01&orientation=landscape',
  alt: '黑吃瓜网黑料存档头条主视觉',
};

export const heroTags = [
  '解散风波',
  '后台录音',
  '合约细节',
  '时间线',
  '同期物料',
  '工作室声明',
  '粉丝互撕',
  '旧料新解',
];

export const sideStories = [
  {
    id: 1,
    category: '黑料整理',
    title: '某国民剧女二片场耍大牌？三条旧料被翻出重新整理',
    time: '4 小时前',
    comments: 642,
    image:
      'https://readdy.ai/api/search-image?query=Close%20up%20of%20scattered%20paparazzi%20camera%20flashes%20and%20lens%20reflections%20in%20warm%20amber%20light%20against%20a%20dark%20blurred%20background%2C%20moody%20editorial%20photography%2C%20high%20contrast&width=400&height=300&seq=hcg-side-01&orientation=landscape',
    alt: '黑料整理专题配图',
  },
  {
    id: 2,
    category: '黑料合集',
    title: '综艺名场面翻车合集更新：这一季的瓜比上一季更硬',
    time: '6 小时前',
    comments: 918,
    image:
      'https://readdy.ai/api/search-image?query=Folded%20entertainment%20newspapers%20and%20glossy%20magazines%20stacked%20on%20a%20warm%20wooden%20table%20with%20soft%20directional%20light%2C%20editorial%20still%20life%2C%20warm%20cream%20and%20amber%20palette&width=400&height=300&seq=hcg-side-02&orientation=landscape',
    alt: '黑料合集专栏配图',
  },
  {
    id: 3,
    category: '黑料存档',
    title: '深夜电台言论失控，完整录音已存入黑料存档专区',
    time: '9 小时前',
    comments: 377,
    image:
      'https://readdy.ai/api/search-image?query=Vintage%20microphone%20and%20headphones%20on%20a%20desk%20under%20warm%20crimson%20lighting%2C%20broadcast%20studio%20still%20life%2C%20moody%20editorial%20photography%2C%20warm%20tones&width=400&height=300&seq=hcg-side-03&orientation=landscape',
    alt: '黑料存档录音专题配图',
  },
];

export const compilations = [
  {
    id: 1,
    category: '黑料合集',
    title: '翻车现场合集：那些年直播里说漏的真心话',
    summary: '32 条直播录像逐条核对时间戳，附前后语境与二次回应，方便一次性看完整套黑料合集。',
    tags: ['直播', '翻车'],
    comments: 1204,
    date: '09-08',
    image:
      'https://readdy.ai/api/search-image?query=Anonymous%20hooded%20figure%20silhouette%20standing%20under%20a%20single%20warm%20spotlight%20on%20a%20dark%20stage%2C%20abstract%20editorial%20photography%2C%20deep%20red%20and%20amber%20tones%2C%20high%20contrast&width=800&height=600&seq=hcg-comp-01&orientation=landscape',
    alt: '黑料合集直播翻车专题封面',
  },
  {
    id: 2,
    category: '黑料整理',
    title: '剧组纷争整理：从加戏传闻到片场对峙的全过程',
    summary: '按拍摄周期排列的 18 段时间线，标注每条物料的原始出处，是本期黑料整理最完整的一份。',
    tags: ['剧组', '时间线'],
    comments: 876,
    date: '09-06',
    image:
      'https://readdy.ai/api/search-image?query=Stack%20of%20archived%20folders%20and%20documents%20tied%20with%20red%20string%20on%20a%20warm%20cream%20desk%2C%20top%20down%20editorial%20still%20life%2C%20soft%20natural%20light%2C%20warm%20amber%20tones&width=800&height=600&seq=hcg-comp-02&orientation=landscape',
    alt: '黑料整理剧组纷争专题封面',
  },
  {
    id: 3,
    category: '黑料存档',
    title: '后台化妆间争议全存档：到底是谁先动的手',
    summary: '三条不同机位的现场素材与两份工作人员口述，全部截取关键帧后归入黑料存档。',
    tags: ['后台', '现场'],
    comments: 1032,
    date: '09-04',
    image:
      'https://readdy.ai/api/search-image?query=Backstage%20dressing%20room%20mirror%20surrounded%20by%20warm%20bulb%20lights%20with%20an%20empty%20chair%2C%20moody%20editorial%20interior%20photography%2C%20warm%20golden%20and%20crimson%20palette&width=800&height=600&seq=hcg-comp-03&orientation=landscape',
    alt: '黑料存档后台化妆间专题封面',
  },
  {
    id: 4,
    category: '黑料合集',
    title: '综艺剪辑争议合集：镜头之外被删掉的三分钟',
    summary: '对比播出正片与路透片段，逐帧标出 9 处剪辑差异，拼成这一份完整的黑料合集。',
    tags: ['综艺', '剪辑'],
    comments: 745,
    date: '09-02',
    image:
      'https://readdy.ai/api/search-image?query=Old%20CRT%20television%20glowing%20with%20static%20in%20a%20dark%20warm%20room%2C%20retro%20editorial%20still%20life%2C%20amber%20and%20deep%20red%20tones%2C%20high%20contrast&width=800&height=600&seq=hcg-comp-04&orientation=landscape',
    alt: '黑料合集综艺剪辑专题封面',
  },
  {
    id: 5,
    category: '黑料整理',
    title: '品牌解约风波整理：一周内发出的七份声明',
    summary: '把七份声明按发布时间排成一条线，标出互相矛盾的三处措辞，完成本轮黑料整理。',
    tags: ['解约', '声明'],
    comments: 534,
    date: '08-30',
    image:
      'https://readdy.ai/api/search-image?query=Crowd%20of%20anonymous%20silhouettes%20raising%20phones%20to%20photograph%20a%20bright%20stage%2C%20warm%20spotlight%20haze%2C%20editorial%20photography%2C%20deep%20amber%20and%20crimson%20palette&width=800&height=600&seq=hcg-comp-05&orientation=landscape',
    alt: '黑料整理品牌解约专题封面',
  },
  {
    id: 6,
    category: '黑料存档',
    title: '老料重提：五年前那条被删掉又被截图保存的动态',
    summary: '从缓存备份中找回原始截图，附上当年的时间背景，补齐黑料存档里缺失的那一页。',
    tags: ['旧料', '备份'],
    comments: 689,
    date: '08-27',
    image:
      'https://readdy.ai/api/search-image?query=Close%20up%20of%20a%20red%20sealed%20envelope%20and%20shredded%20paper%20scraps%20on%20a%20warm%20cream%20surface%2C%20mysterious%20editorial%20still%20life%2C%20soft%20directional%20light&width=800&height=600&seq=hcg-comp-06&orientation=landscape',
    alt: '黑料存档旧料重提专题封面',
  },
];

export const topics = [
  { icon: 'ri-live-line', name: '直播翻车', count: 128, latest: '某主播情绪失控连麦片段' },
  { icon: 'ri-mic-line', name: '录音泄露', count: 76, latest: '后台争执录音完整版' },
  { icon: 'ri-movie-2-line', name: '剧组内幕', count: 94, latest: '加戏传闻时间线核对' },
  { icon: 'ri-group-line', name: '团队解散', count: 41, latest: '组合合约细节整理' },
  { icon: 'ri-hand-heart-line', name: '人设翻车', count: 152, latest: '公益形象前后对比' },
  { icon: 'ri-file-list-3-line', name: '声明合集', count: 63, latest: '一周七份声明逐条拆解' },
];

export const hotTopics = [
  { id: 1, title: '这场解散风波里，到底是谁先违约的？', heat: 9821, replies: 2143, tag: '沸' },
  { id: 2, title: '三年前那条动态现在看是不是提前埋的伏笔', heat: 7420, replies: 1687, tag: '热' },
  { id: 3, title: '七份声明里最站不住脚的是哪一份，投票看看', heat: 6103, replies: 1320, tag: '热' },
  { id: 4, title: '录音里的那句到底是不是剪辑拼的，求技术流分析', heat: 4875, replies: 968, tag: '议' },
  { id: 5, title: '如果当年没删动态，整个黑料存档会不会完全不同', heat: 3540, replies: 712, tag: '议' },
];

export const comments = [
  {
    id: 1,
    name: '吃瓜不吐籽',
    initial: '瓜',
    time: '12 分钟前',
    content: '这份黑料整理的时间线做得太细了，连物料出处都标好了，省得我自己一条条翻，感谢存档。',
    likes: 328,
    role: '常驻吃瓜',
  },
  {
    id: 2,
    name: '存档管理员',
    initial: '档',
    time: '26 分钟前',
    content: '旧料已经二次核对完成，前后语境补上了。大家看黑料合集的时候记得先看时间戳，别被带偏。',
    likes: 512,
    role: '官方整理',
  },
  {
    id: 3,
    name: '冷静看戏的人',
    initial: '静',
    time: '48 分钟前',
    content: '说实话黑料大全翻下来，真正有实锤的没几条，剩下的全是二手转述，还是存档完整版靠谱一点。',
    likes: 245,
    role: '理性派',
  },
  {
    id: 4,
    name: '昨天才入坑',
    initial: '坑',
    time: '1 小时前',
    content: '刚来黑吃瓜网就赶上大瓜，请问从哪里开始看比较清楚，有没有推荐的入门黑料整理路线。',
    likes: 189,
    role: '新瓜友',
  },
];

export const archiveTimeline = [
  {
    date: '09-08',
    weekday: '本周一',
    title: '直播翻车黑料合集打包完成，共 32 条记录',
    desc: '统一补齐时间戳与前后语境，删除两条无法核实的转述内容，完成本轮归档。',
    tag: '黑料合集',
    image:
      'https://readdy.ai/api/search-image?query=Small%20polaroid%20photos%20scattered%20on%20a%20warm%20cream%20surface%2C%20top%20down%20editorial%20still%20life%2C%20soft%20light%2C%20warm%20amber%20tones&width=200&height=200&seq=hcg-time-01&orientation=squarish',
    alt: '黑料存档时间线条目配图',
  },
  {
    date: '09-05',
    weekday: '上周五',
    title: '后台录音完整版入库，同步开放听感整理笔记',
    desc: '邀请三位听众独立标注关键段落，交叉比对后形成一份可查证的黑料整理说明。',
    tag: '黑料整理',
    image:
      'https://readdy.ai/api/search-image?query=Rolled%20up%20old%20newspaper%20with%20a%20magnifying%20glass%20on%20a%20warm%20wooden%20surface%2C%20editorial%20still%20life%2C%20soft%20natural%20light&width=200&height=200&seq=hcg-time-02&orientation=squarish',
    alt: '黑料整理时间线条目配图',
  },
  {
    date: '09-01',
    weekday: '本月一日',
    title: '五年旧料从缓存备份中找回，补全存档缺口',
    desc: '原始截图与删除时间均已记录，归入黑料存档并标注为可回溯条目。',
    tag: '黑料存档',
    image:
      'https://readdy.ai/api/search-image?query=Calendar%20page%20with%20a%20red%20circle%20marking%20and%20a%20coffee%20cup%20on%20a%20warm%20desk%2C%20editorial%20still%20life%2C%20soft%20light&width=200&height=200&seq=hcg-time-03&orientation=squarish',
    alt: '黑料存档时间线条目配图',
  },
  {
    date: '08-28',
    weekday: '上月二十八',
    title: '黑料大全总目录上线，支持按年份与题材检索',
    desc: '把过往零散条目重新编号，形成一份可以长期维护的黑料大全总表。',
    tag: '黑料大全',
    image:
      'https://readdy.ai/api/search-image?query=Stack%20of%20film%20negative%20strips%20on%20a%20lightbox%20glowing%20warm%20amber%2C%20editorial%20still%20life%2C%20warm%20tones&width=200&height=200&seq=hcg-time-04&orientation=squarish',
    alt: '黑料大全时间线条目配图',
  },
];

export const ranking = [
  { rank: 1, title: '顶流组合解散风波全程存档', category: '黑料存档', heat: 98600, trend: 'up' },
  { rank: 2, title: '直播翻车真心话合集（32 条）', category: '黑料合集', heat: 87320, trend: 'up' },
  { rank: 3, title: '剧组加戏传闻完整时间线', category: '黑料整理', heat: 76150, trend: 'same' },
  { rank: 4, title: '后台化妆间争议三机位素材', category: '黑料存档', heat: 68940, trend: 'up' },
  { rank: 5, title: '综艺被删掉的三分钟对比', category: '黑料合集', heat: 58470, trend: 'down' },
  { rank: 6, title: '一周七份声明逐条拆解', category: '黑料整理', heat: 47210, trend: 'same' },
  { rank: 7, title: '人设前后对比整理专题', category: '黑料整理', heat: 39860, trend: 'up' },
  { rank: 8, title: '五年前被删动态恢复记录', category: '黑料存档', heat: 31540, trend: 'down' },
];

export const footerColumns = [
  {
    title: '存档入口',
    links: [
      { label: '黑料存档专区', href: '#archive' },
      { label: '黑料合集总览', href: '#compilation' },
      { label: '黑料整理专题', href: '#topics' },
      { label: '黑料大全排行榜', href: '#ranking' },
    ],
  },
  {
    title: '内容分类',
    links: [
      { label: '直播翻车', href: '#topics' },
      { label: '录音泄露', href: '#topics' },
      { label: '剧组内幕', href: '#topics' },
      { label: '声明合集', href: '#topics' },
    ],
  },
  {
    title: '互动专区',
    links: [
      { label: '热议话题', href: '#discussion' },
      { label: '最新评论', href: '#discussion' },
      { label: '投稿线索', href: '#discussion' },
      { label: '纠错反馈', href: '#discussion' },
    ],
  },
];